import api from '../token';

export const AddProcessoCompraFornecedor = async (dados) => {
  try {
    const response = await api.post('/compraFornecedor', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
